import React, { useState, useRef } from 'react';
import {
    Typography,
    TextField,
    Button,
    Divider,
    CardContent,
    IconButton,
    Box,
    Card,
    CardHeader,
    Grid
} from '@mui/material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Download } from "@mui/icons-material";
import styles from './Styles';
import { post } from "../../services";

import Cookies from "js-cookie";
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import axios from "axios";
import { SSPCommonButton } from '../../CommonComponents';
import * as FileSaver from "file-saver";
import Loader from "../../CommonComponents/Loader";

const SecondTab = ({ row, perviousRowFetch }) => {

    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    const id = Cookies.get("ssp_domain_id");
    const base = "https://";
    // Prod Lambda URL prefix
    const prodEndpoint = "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/";

    const handleFileSelect = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const downloadFile = async (path) => {
        let response = await post(
            base + prodEndpoint + "asset_qr_dowload_file",
            {
                file_name: path,
                domain_id: id,
                source: "SSP"
            },
            true,
            false
        );
        if (response?.status === "success") {
            window.open(response?.url);
        } else {
            setmessage(response?.message);
            setmodalOpener(true);
        }
    };

    const downloadProcessLog = async (logId) => {
        let response = await post(
            base + prodEndpoint + "asset_qr_processlog",
            {
                log_id: logId,
                source: "SSP"
            },
            true,
            false
        );
        if (response?.status === "success") {
            // Updated to match Dev code logic for mapping Excel data
            let data1 = response?.data.map((obj) => ({
                message: obj.error_message,
                asset_id: obj.asset_id,
                category: obj.category,
                loc: obj.loc,
            }));
            DownloadExcelSheet(data1, "PL");
        } else {
            setmessage(response?.message);
            setmodalOpener(true);
        }
    }

    const ExcelJS = require("exceljs");
    const DownloadExcelSheet = async (response, fileName) => {
        if (response !== null && response.length > 0) {
            let data = response;
            const workbook = new ExcelJS.Workbook();
            const headers = Object.keys(data[0]);
            const worksheet = workbook.addWorksheet("data");
            const firstRow = worksheet.getRow(1);

            for (let i = 1; i <= headers?.length; i++) {
                const cell = firstRow.getCell(i);
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFFFA500" },
                };
            }

            worksheet.columns = headers.map((header) => ({ header, key: header }));
            data.forEach((dataRow) => {
                worksheet.addRow(dataRow);
            });
            worksheet.columns.forEach((column) => {
                column.width = 25;
            });

            const currentTimestamp = new Date().toISOString().replace(/[-T:.Z]/g, '');
            const generatedFileName = `${fileName}_${currentTimestamp}.xlsx`;

            workbook.xlsx.writeBuffer().then((buffer) => {
                const data = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                FileSaver.saveAs(data, generatedFileName);
            });
        } else {
            setmessage("No data provided to download the file");
            setmodalOpener(true);
        }
    };

    const columns = [
        {
            field: "log_id",
            headerName: "Log ID",
            flex: 0.7,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={styles.logIdCell}>
                    {params.value}
                </div>
            )
        },
        {
            field: "file_name",
            headerName: "File Name",
            flex: 1,
            renderCell: (params) => (
                <div style={styles.fileNameCell}>
                    {params.row.file_name ? params.row.file_name : 'No File Available'}
                </div>
            )
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const statusStyles = {
                    fontWeight: '600',
                    color: params.value === 'Success' ? 'green' : 'red',
                };
                return (
                    <div style={statusStyles}>
                        {params.value}
                    </div>
                )
            }
        },
        {
            field: "count",
            headerName: "Count",
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={styles.countCell}>
                    {params.value}
                </div>
            )
        },
        {
            field: "create_date",
            headerName: "Create Date",
            flex: 0.8,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={styles.createDateCell}>
                    {params.value}
                </div>
            )
        },
        {
            field: "tag_file_path",
            headerName: "File",
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div>
                    <IconButton
                        aria-label="Download"
                        onClick={() => downloadFile(params.row.tag_file_path)}
                    >
                        <Download color="primary" />
                    </IconButton>
                </div>
            ),
        },
        {
            field: "process_log",
            headerName: "Process Log",
            flex: 0.7,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={styles.processLogCell}>
                    <IconButton
                        aria-label="Download Process Log"
                        onClick={() => downloadProcessLog(params.row.log_id)}
                    >
                        <Download color="primary" />
                    </IconButton>
                </div>
            ),
        }
    ];

    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            return !!fileUploaded;
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);
            return response.status === 204 || (response.status >= 200 && response.status < 300);
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const handleUploadFile = async () => {
        if (selectedFile) {
            setLoading(true);
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }

            let presignedUrlResponse = await post(
                base + prodEndpoint + "gen_pre_url",
                {
                    file_name: "uploads/asset_qr_upload/" + filenameWithTimestamp,
                    source: "SSP"
                },
                true,
                false
            );

            const presignedUrl = presignedUrlResponse.data.response;
            if (!presignedUrl) {
                setLoading(false);
                console.error("Presigned URL is not valid");
                return;
            }

            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(selectedFile, presignedUrl);
                if (fileUploaded) {
                    let response = await post(
                        base + prodEndpoint + "asset_qr_duplicate_upload",
                        {
                            file_name: presignedUrl?.fields?.key,
                            domain_id: id,
                            source: "SSP"
                        },
                        true,
                        false
                    );
                    setLoading(false);
                    if (response?.status === "success") {
                        setmessage("File Uploaded");
                        perviousRowFetch();
                        if (fileInputRef.current) fileInputRef.current.value = "";
                        setSelectedFile(null);
                    } else {
                        setmessage(response?.message);
                        perviousRowFetch();
                        if (fileInputRef.current) fileInputRef.current.value = "";
                        setSelectedFile(null);
                    }
                    setmodalOpener(true);
                } else {
                    setLoading(false);
                    if (fileInputRef.current) fileInputRef.current.value = "";
                    setSelectedFile(null);
                }
            }
        } else {
            setLoading(false);
            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    };

    const handleDownloadSampleFile = async () => {
        let response = await post(
            base + prodEndpoint + "duplicate_sample_download",
            {
                domain_id: id,
                source: "SSP"
            },
            true,
            false
        );
        if (response?.status === "success") {
            window.open(response?.url);
        } else {
            setmessage(response?.message);
            setmodalOpener(true);
        }
    };

    return (
        <div style={styles.tabContent}>
            <Loader loading={loading} />
            <div style={styles.uploadFileBox}>
                <Grid item xs={4} sx={{ backgroundColor: "white" }}>
                    <Typography>
                        <b style={{ color: "red" }}>&nbsp;&nbsp;&nbsp;*&nbsp;</b>
                        Select file to be uploaded
                    </Typography>
                    <Box p={2} sx={{ display: { lg: "flex", md: "flex" }, gap: "1rem" }}>
                        <Box p={1} sx={{ border: "1px solid lightgrey", borderRadius: "5px" }}>
                            <input
                                type="file"
                                ref={fileInputRef}
                                multiple={false}
                                onChange={handleFileSelect}
                            />
                        </Box>
                    </Box>
                </Grid>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: 10 }}>
                        <SSPCommonButton
                            btnText={"Upload File"}
                            btnFunction={() => handleUploadFile()}
                        />
                        <Button
                            style={styles.sampleFileLink}
                            onClick={() => handleDownloadSampleFile()}
                        >
                            Download Sample File
                        </Button>
                    </div>
                </div>
            </div>

            <Card sx={{ backgroundColor: "#EEF2F7", padding: "1.3rem" }}>
                <CardHeader
                    sx={{ backgroundColor: "#F8F8F9", borderTopRightRadius: "5px", borderTopLeftRadius: "5px" }}
                    title={" Previous Uploads"}
                    titleTypographyProps={{ sx: { fontSize: "16px", fontWeight: "600", color: "#0160F1" } }}
                    action={<Button onClick={() => window.location.reload()}>Refresh Page</Button>}
                />
                <Divider />
                <CardContent sx={{ backgroundColor: "#FFFFFF", borderBottomRightRadius: "5px", borderBottomLeftRadius: "5px" }}>
                    <Box sx={{ height: 700, width: "100%" }}>
                        <DataGrid
                            disableColumnMenu={true}
                            rowHeight={80}
                            showCellRightBorder={true}
                            sx={{
                                ".MuiDataGrid-columnHeaderTitle": { fontWeight: "bold !important" },
                                ".MuiDataGrid-cell": { fontSize: "0.8rem" },
                                overflowX: "scroll",
                            }}
                            rows={row}
                            columns={columns}
                            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                            getRowId={(row) => row.id}
                            components={{ Toolbar: GridToolbar }}
                            componentsProps={{
                                Toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                    </Box>
                </CardContent>
                {modalOpener && (
                    <SSPCommonModal
                        open={modalOpener}
                        handleOpenClose={setmodalOpener}
                        message={message}
                    />
                )}
            </Card>
        </div>
    );
};

export default SecondTab;